<template>
  <div class="icon-button d-flex justify-content-between align-items-center" style="padding: 1rem 1.5rem;">
    <div @click="handleBackClick">
      <img src="../static/images/backIcon.png" width="39px" alt="">
    </div>
    <span class="label" v-html="$t(label)"></span>
    <div style="display: flex; gap: 1rem;">
      <!-- <img @click="handleSupportClick" src="../static/images/support.png" width="34px" alt=""> -->
      <img @click="handleRecordClick" src="../static/images/record.png" width="36px" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleBackClick() {
      this.$emit('backClick');
    },
    handleSupportClick() {
      this.$router.push('information-center/support')
    },
    handleRecordClick() {
      this.$router.push('rechargeRecord')
    },
  },
}
</script>

<style lang="less" scoped>
.icon-button {
  background: #F0FBFF;
  box-shadow: 0px 2px 5.9px 0px #0000001A;
  border-radius: 0 0 50px 50px;
  // cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0rem;
  padding: 2rem 0px;
}

.icon {
  width: 30px;
  @media (max-width: 540px) {
    width: 20px !important;
    height: 20px !important;
  }
}

.label {
  font-family: Teko, sans-serif;
  text-transform: uppercase;
  color: #000000;
  font-size: 31px;
  font-weight: 700;
  padding-left: 2rem;
  @media (max-width: 540px) {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activitiesBackButton.vue